import type { Language } from "./types";

const es = {
  appName: "Pulso",
  appCountry: "Colombia",
  appTagline: "Red comunitaria de ayuda",
  pageTitle: "Pulso Colombia | Mapa comunitario de ayuda",
  pageDescription: "Aplicación comunitaria bilingüe para reportar necesidades, ofrecer ayuda y coordinar apoyo en Colombia.",
  map: "Mapa comunitario de necesidades y ayuda",
  communityHubIntro: "Reporta necesidades, ofrece ayuda y conecta con tu comunidad.",
  communityReports: "Publicaciones comunitarias",
  officialMapReference: "Consultar mapa oficial Copernicus EMSR916",
  peopleLabel: "Personas reportadas",
  urgentSectors: "Sectores urgentes",
  urgentReports: "{count} reportes urgentes",
  skipToFeed: "Saltar al listado",
  emergency: "¿Peligro inmediato? Llama al 123",
  verifiedEvent: "Evento oficial verificado",
  eventFallback: "Actualizando datos del sismo",
  updated: "Actualizado",
  agoMinutes: "hace {count} min",
  agoHours: "hace {count} h",
  agoDays: "hace {count} d",
  needHelp: "Necesito ayuda",
  offerHelp: "Quiero ayudar",
  signIn: "Ingresar",
  signOut: "Salir",
  inbox: "Mensajes",
  messagesCount: "{count} mensajes",
  admin: "Administrar",
  adminTitle: "Administrar publicaciones",
  adminIntro:
    "Esta vista solo aparece para la cuenta moderadora. Puedes eliminar permanentemente publicaciones de prueba, duplicadas o inseguras.",
  adminPostBy: "Por {name}",
  noAdminPosts: "No hay publicaciones activas para administrar.",
  inboxLoadError: "No se pudieron actualizar los mensajes.",
  inboxSignedInAs: "Cuenta: {name}",
  inboxAccountHint: "ID de cuenta {id}",
  inboxDeviceHint:
    "Para ver la misma bandeja en otro dispositivo, elige «Ya tengo un código» e ingresa el mismo código privado. Crear cuenta genera una bandeja distinta.",
  refreshInbox: "Actualizar",
  refreshingInbox: "Actualizando",
  backToMessages: "Volver a mensajes",
  selectConversation: "Selecciona una conversación",
  selectConversationHint:
    "Abre un mensaje para coordinar de forma privada.",
  waitingForResponse:
    "La otra persona debe aceptar esta oferta antes de abrir el chat.",
  conversationClosed:
    "Esta conversación está cerrada y es de solo lectura.",
  language: "Idioma",
  selectCity: "Ciudad o región",
  allCities: "Todas",
  needsTab: "Comunidad",
  areasTab: "Barrios y sectores",
  resourcesTab: "Recursos",
  openNeeds: "{count} publicaciones activas",
  noReportsTitle: "Aún no hay publicaciones en esta zona",
  noReportsBody:
    "Publica una necesidad, ayuda disponible o actualización y ubícala de forma aproximada en el mapa.",
  filters: "Filtros",
  filterAll: "Todo",
  statusOpen: "Abierto",
  statusMatched: "Ayuda coordinada",
  statusResolved: "Resuelto",
  reportDetails: "Detalle de la necesidad",
  availableHelpDetails: "Detalle de la ayuda disponible",
  communityUpdateDetails: "Actualización comunitaria",
  reportedBy: "Publicado por {name}",
  officialIntensity: "Intensidad instrumental",
  communityConfirmations: "Confirmación comunitaria",
  urgency: "Urgencia",
  severityLegend: "Colores de urgencia del 1 al 5",
  urgencyLevel: "Urgencia {count} de 5",
  people: "{count} personas",
  onePerson: "1 persona",
  confirmations: "{count} confirmaciones",
  oneConfirmation: "1 confirmación",
  confirm: "Confirmar en la zona",
  confirmed: "Confirmado",
  sendOffer: "Enviar oferta",
  contactAvailableHelp: "Contactar",
  replyPrivately: "Responder",
  manage: "Gestionar",
  editPost: "Editar",
  reportFlag: "Reportar",
  discussion: "Conversación pública",
  discussionCount: "{count} comentarios",
  commentsLoading: "Cargando conversación",
  commentsLoadError: "No se pudo cargar la conversación.",
  noComments: "Aún no hay comentarios.",
  commentPlaceholder: "Escribe un comentario público",
  publicCommentNote: "No compartas teléfonos, correos ni datos sensibles.",
  publishComment: "Comentar",
  publishingComment: "Publicando",
  signInToComment: "Ingresa para comentar",
  commentsClosed: "La conversación se cerró al resolver esta publicación.",
  verifiedRepresentative: "Representante verificado",
  communityMember: "Miembro de la comunidad",
  approximateLocation: "Ubicación aproximada",
  mapLayers: "Capas",
  baseMap: "Mapa base",
  streetMap: "Calles",
  referenceImagery: "Satélite base",
  satellite: "Satélite diario",
  nasaDailyImagery: "NASA diario (375 m)",
  shaking: "Intensidad USGS",
  modeledShaking: "Sacudida modelada USGS",
  observedShaking: "Sacudida reportada al USGS",
  officialDamageLayer: "Daño oficial Copernicus",
  communityNeeds: "Red comunitaria",
  aftershocks: "Réplicas",
  satelliteDate: "Fecha de imagen",
  satelliteResolution: "NASA VIIRS, resolución aproximada de 375 m. No permite inspeccionar edificios.",
  locateMe: "Usar mi ubicación",
  locating: "Buscando ubicación",
  locationError: "No se pudo acceder a tu ubicación.",
  zoomIn: "Acercar",
  zoomOut: "Alejar",
  prioritySignal: "Índice de prioridad",
  priorityNote: "Combina intensidad USGS y reportes comunitarios. No es una inspección de daños.",
  noOfficialMmi: "Sin estimación MMI",
  mmiLabel: "MMI {value}",
  modeledMmi: "MMI modelada {value}",
  observedCdi: "CDI observada {value}",
  modelCellResolution: "Celda del modelo de ~{value} km",
  notObservedDamage: "No es daño observado.",
  modeledNotDamage: "Modelo USGS; no es inspección de daños",
  dyfiResponses: "{count} respuestas sentidas al USGS",
  noDyfiResponses: "Sin respuestas DYFI en esta ciudad",
  feltNotDamage: "Sacudida sentida; no es daño de edificios.",
  reportsLabel: "{count} reportes",
  oneReport: "1 reporte",
  strongShaking: "Sacudida fuerte",
  moderateShaking: "Sacudida moderada",
  lightShaking: "Sacudida leve",
  liveSources: "Fuentes y metodología",
  dataSources: "Fuentes de datos",
  usgsSource: "USGS: evento, réplicas, ShakeMap y riesgos del terreno.",
  nasaSource: "NASA GIBS/VIIRS: imagen diaria de reflectancia visible.",
  copernicusSource:
    "Copernicus EMSR916: puntos de edificios clasificados por fotointerpretación de imágenes VHR y vías interrumpidas, únicamente dentro de sus áreas analizadas.",
  communitySource: "Comunidad: necesidades, confirmaciones y estado de coordinación.",
  methodology: "Cómo se calcula",
  methodologyBody:
    "Los sectores locales son celdas H3 de cerca de 350 m. El orden de triaje usa 60×(1−exp(−(5D+3A+P)/12)) para hallazgos Copernicus destruidos (D), dañados (A) y posiblemente dañados (P); hasta 30 puntos por necesidades comunitarias; y hasta 10 por MMI modelada. La interfaz muestra los componentes, no una falsa cifra de daño.",
  limitations: "Limitaciones",
  limitationsBody:
    "Copernicus solo confirma hallazgos dentro de sus áreas analizadas; una zona vacía o pendiente no significa que no haya daño. Nubes, vegetación y resolución pueden ocultarlo. La imagen Esri es de referencia y su fecha varía; NASA VIIRS no inspecciona edificios. Verifica en terreno antes de asignar recursos.",
  openOfficialSource: "Abrir fuente oficial",
  authTitle: "Tu cuenta Pulso",
  authIntro: "No necesitas correo. Tu código privado te permite volver a entrar desde otro dispositivo.",
  createAccount: "Crear cuenta",
  restoreAccount: "Ya tengo un código",
  displayName: "Nombre público o alias",
  displayNameHint: "No publiques tu nombre legal si no es necesario.",
  yourCity: "Tu ciudad o región",
  primaryCommunity: "Comunidad principal",
  primaryCommunityNote:
    "Elige donde vives o la comunidad que deseas apoyar, incluso si estás fuera de Colombia.",
  accountType: "¿Cómo participas?",
  accountResident: "Comunidad",
  accountVolunteer: "Voluntariado",
  accountSponsor: "Organización o donante",
  accountTypeNote: "Esta elección es informativa y no implica verificación.",
  securityCheck: "Verificación de seguridad",
  securityCheckError: "No se pudo cargar la verificación de seguridad. Intenta de nuevo.",
  recoveryCode: "Código privado de acceso",
  recoveryPlaceholder: "PULSO-XXXX-XXXX-...",
  continue: "Continuar",
  creating: "Creando cuenta",
  loggingIn: "Ingresando",
  recoveryTitle: "Guarda tu código privado",
  recoveryBody:
    "Pulso no puede recuperar este código. Guárdalo fuera de este dispositivo y no lo publiques.",
  copyCode: "Copiar código",
  codeCopied: "Código copiado",
  done: "Listo",
  needFormTitle: "Publicar una necesidad",
  needFormIntro:
    "Busca una dirección o toca el mapa. La dirección exacta se descarta y Pulso publica solo un pin aproximado.",
  offerFormTitle: "Publicar ayuda disponible",
  offerFormIntro:
    "Publica ayuda presencial con un pin o apoyo remoto desde cualquier país.",
  updateFormTitle: "Publicar una actualización",
  updateFormIntro:
    "Comparte un aviso corto y localizado sobre recursos, accesos, recaudos o condiciones del sector.",
  editPostTitle: "Editar publicación",
  editPostIntro:
    "Corrige la información, categorías o ubicación aproximada. Las confirmaciones comunitarias se reinician al guardar.",
  existingApproximateLocation: "Ubicación aproximada actual",
  needPost: "Necesidad",
  offerPost: "Ayuda disponible",
  helpDeliveryMode: "¿Dónde está disponible la ayuda?",
  localHelp: "En la zona",
  remoteHelp: "Ayuda remota",
  localHelpModeNote:
    "Publica un pin aproximado para que la comunidad pueda encontrar esta ayuda local.",
  remoteHelpModeNote:
    "Ofrece apoyo desde cualquier país sin publicar tu ubicación personal.",
  communityToSupport: "Comunidad que deseas apoyar",
  remoteHelperLocationPrivate:
    "Tu ubicación no se solicita ni se publica.",
  supportingCommunity: "Apoyo remoto para {city}",
  remoteHelpFor: "Ayuda remota para {city}",
  updatePost: "Actualización",
  mapInstruction: "Toca el mapa para elegir una ubicación aproximada.",
  selectedLocation: "Ubicación seleccionada",
  chooseLocation: "Elegir en el mapa",
  findLocation: "Ubica el reporte",
  addressPlaceholder: "Dirección, barrio o punto de referencia",
  searchAddress: "Buscar dirección",
  addressResults: "Resultados de dirección",
  addressSearchMinimum: "Escribe al menos 3 caracteres para buscar.",
  addressNoResults: "No encontramos ese lugar dentro de la ciudad seleccionada.",
  mapClickFallback: "También puedes tocar el mapa",
  locationMap: "Mapa para elegir la ubicación aproximada",
  mapPointSelected: "Punto elegido en el mapa",
  deviceLocationSelected: "Ubicación del dispositivo",
  locationOutsideCity: "El punto debe quedar dentro de la ciudad o región seleccionada.",
  publicCellPreview: "solo se publicará un pin aproximado; la dirección exacta permanece oculta",
  locationSelectionHint: "Busca, usa tu ubicación o toca el mapa.",
  addressSearchCredit:
    "La consulta se envía a Nominatim; Pulso no guarda el texto de búsqueda. Datos:",
  neighborhood: "Barrio o sector",
  neighborhoodPlaceholder: "Ej. La Enea",
  needs: "¿Qué se necesita?",
  selectMultipleNeeds: "Puedes seleccionar todas las categorías que correspondan.",
  needsSelected: "{count} seleccionadas: {needs}",
  offerCategories: "¿Qué puedes ofrecer?",
  updateCategories: "Tema de la actualización",
  needWater: "Agua",
  needFood: "Alimentos",
  needShelter: "Refugio",
  needMedical: "Atención médica",
  needHygiene: "Higiene",
  needRescue: "Rescate",
  needTransport: "Transporte",
  needInformation: "Información",
  needFunds: "Apoyo económico",
  affectedPeople: "Personas afectadas",
  peopleCanHelp: "Personas que puedes apoyar",
  urgencyQuestion: "¿Qué tan urgente es?",
  urgency1: "Puede esperar",
  urgency3: "Urgente",
  urgency5: "Crítico",
  details: "Descripción",
  detailsPlaceholder:
    "Explica qué ocurrió, qué hace falta, cantidades, personas afectadas, desde cuándo y restricciones de acceso.",
  offerDetailsPlaceholder:
    "Detalla qué puedes ofrecer, cantidades, horarios, cobertura, entrega o recogida y condiciones.",
  updateDetailsPlaceholder:
    "Indica qué cambió, lugar y hora, fuente, impacto para la comunidad y cómo puede verificarse.",
  needDetailsHint:
    "Incluye cantidades, urgencia, accesibilidad y contexto verificable. Mantén teléfonos y datos financieros en mensajes privados.",
  offerDetailsHint:
    "Aclara capacidad, disponibilidad, transporte y límites. Comparte contacto personal solo en una conversación privada aceptada.",
  updateDetailsHint:
    "Añade fecha, fuente y efecto práctico. No publiques teléfonos, cuentas bancarias ni datos personales.",
  privacyWarning:
    "No publiques dirección exacta, teléfono, correo, cuentas bancarias ni nombres de menores. Tras aceptar una conexión confiable, coordina datos de contacto por Mensajes.",
  publishReport: "Publicar necesidad",
  publishOffer: "Publicar ayuda",
  publishUpdate: "Publicar actualización",
  publishing: "Publicando",
  saveChanges: "Guardar cambios",
  savingChanges: "Guardando",
  postUpdated: "Publicación actualizada",
  reportPublished: "Necesidad publicada",
  helpPublished: "Ayuda disponible publicada",
  updatePublished: "Actualización publicada",
  donateTitle: "Ayudar con seguridad",
  donateIntro:
    "Elige una organización oficial o responde a una necesidad concreta mediante un mensaje privado.",
  officialOrganizations: "Organizaciones oficiales",
  directSupport: "Apoyo directo",
  directSupportBody:
    "Abre una necesidad del mapa y envía una oferta. La persona decide si acepta antes de coordinar detalles.",
  postAvailableHelp: "Publicar ayuda disponible",
  postUpdate: "Publicar",
  browseNeeds: "Ver necesidades",
  donationSafety: "Verifica el dominio y el destinatario. Pulso no procesa dinero ni cobra comisiones.",
  officialInfo: "Información oficial",
  externalLink: "Abre un sitio externo",
  offerTitle: "Ofrecer ayuda",
  offerTo: "Oferta para {name}",
  contactTo: "Contactar a {name}",
  offerType: "Tipo de ayuda",
  offerSupplies: "Suministros",
  offerTransport: "Transporte",
  offerShelter: "Alojamiento",
  offerMedical: "Apoyo médico",
  offerVolunteer: "Voluntariado",
  offerFunds: "Aporte económico",
  offerOther: "Otro",
  privateMessage: "Mensaje privado",
  privateMessagePlaceholder: "Explica qué puedes aportar y cómo prefieres coordinar.",
  contactMessagePlaceholder: "Explica qué necesitas y cómo prefieres coordinar de forma segura.",
  replyMessagePlaceholder: "Escribe una respuesta privada y explica cómo puede verificarse.",
  privateReply: "Respuesta privada",
  responsePlaceholder: "Comparte cómo continuar. Aquí sí puedes incluir un contacto si decides hacerlo.",
  acceptResponse: "Aceptar y abrir chat",
  privateChat: "Chat privado",
  openChat: "Abrir chat",
  closeChat: "Cerrar chat",
  chatMessagePlaceholder: "Escribe un mensaje",
  sendMessage: "Enviar mensaje",
  noChatMessages: "Aún no hay mensajes en este chat.",
  refreshChat: "Actualizar chat",
  sendPrivateOffer: "Enviar oferta privada",
  sendPrivateMessage: "Enviar mensaje privado",
  sending: "Enviando",
  offerSent: "Oferta enviada",
  messageSent: "Mensaje enviado",
  inboxTitle: "Mensajes privados",
  received: "Recibidos",
  sent: "Enviados",
  noMessages: "Aún no hay conversaciones privadas.",
  accept: "Aceptar",
  decline: "Rechazar",
  withdraw: "Retirar",
  accepted: "Aceptada",
  declined: "Rechazada",
  withdrawn: "Retirada",
  pending: "Pendiente",
  statusAvailable: "Disponible",
  statusCoordinating: "En coordinación",
  statusClosed: "Cerrada",
  statusPublished: "Publicada",
  offerExcludedFromRisk:
    "La ayuda disponible y las actualizaciones no modifican el índice de prioridad ni la estimación de personas afectadas.",
  fundraiserSafety:
    "Los recaudos y enlaces de pago son información comunitaria no verificada. No publiques credenciales ni datos bancarios y verifica al destinatario antes de contribuir.",
  coordinationSafety:
    "Comparte datos personales solo si confías en la otra persona. Pulso no verifica ofertas individuales y elimina mensajes después de 30 días.",
  close: "Cerrar",
  cancel: "Cancelar",
  save: "Guardar",
  markResolved: "Marcar resuelto",
  reopen: "Reabrir",
  closePost: "Cerrar publicación",
  reopenPost: "Volver a publicar",
  deletePost: "Eliminar",
  deletePostConfirmTitle: "¿Eliminar esta publicación?",
  deletePostWarning:
    "Esta acción es permanente y también elimina sus comentarios, conexiones y chat privado.",
  deletePermanently: "Eliminar permanentemente",
  postDeleted: "Publicación eliminada",
  reportReason: "¿Por qué reportas esta publicación?",
  reasonIncorrect: "Información incorrecta",
  reasonDuplicate: "Duplicada",
  reasonUnsafe: "Expone datos personales",
  reasonFraud: "Posible fraude",
  reasonOther: "Otro",
  flagSent: "Reporte enviado",
  loading: "Cargando datos en vivo",
  refresh: "Actualizar",
  retry: "Reintentar",
  genericError: "Algo salió mal. Intenta de nuevo.",
  offline: "Sin conexión. Mostrando la última información disponible.",
  sourceOnline: "Datos en vivo",
  sourceCached: "Último dato oficial",
  imageryContext: "Imagen de contexto",
  evidenceOfficial: "Oficial",
  evidenceCommunity: "Comunidad",
  eventDepth: "{value} km de profundidad",
  eventFelt: "{count} reportes al USGS",
  redAlert: "Alerta roja USGS",
  landslideAlert: "Riesgo de deslizamiento: {value}",
  liquefactionAlert: "Riesgo de licuefacción: {value}",
  footerDisclaimer: "Herramienta comunitaria. En una emergencia inmediata, llama al 123.",
  charCount: "{count}/{max}",
  required: "Obligatorio",
  locationPending: "Falta elegir ubicación",
  categoryPending: "Selecciona al menos una categoría.",
  detailsPending: "Describe la situación con al menos 10 caracteres.",
  securityPending: "Completa la verificación de seguridad.",
  accountRequired: "Inicia sesión para continuar.",
  loadFailure: "No se pudieron cargar los datos en vivo.",
  satelliteLoadHint: "La imagen puede tardar o tener nubes.",
  cityScope: "En {city}",
  officialMappedArea: "Área analizada",
  copernicusAcquisition: "{sensor}, imagen del {date}",
  destroyedBuilding: "Edificio destruido",
  damagedBuilding: "Edificio dañado",
  possiblyDamagedBuilding: "Edificio posiblemente dañado",
  copernicusPhotoInterpretation: "Fotointerpretación oficial Copernicus EMS",
  blockedRoad: "Vía bloqueada o interrumpida",
  blockedRoadsCount: "{count} vías interrumpidas",
  communityPriority: "Prioridad de necesidad comunitaria",
  officialDamageFindings: "{count} hallazgos oficiales de edificios",
  officialMappingPending: "Mapeo oficial por bloques pendiente",
  layerEvidenceNote:
    "Los puntos CEMS son daño observado. DYFI es sacudida reportada y MMI es modelada; no son daños de edificios.",
  neighborhoodEvidence: "Evidencia por barrio y sector",
  neighborhoodEvidenceNote:
    "Ordenado por hallazgos Copernicus, necesidades críticas y sacudida modelada. Cada fila muestra los componentes disponibles; un área sin cobertura no equivale a ausencia de daño.",
  officialCoverageAvailable: "Cobertura oficial por bloques disponible",
  mappedSector: "Sector cartografiado {count}",
  priorityCritical: "Crítico",
  priorityHigh: "Alto",
  priorityActive: "Activo",
  destroyedCount: "{count} destruidos",
  damagedCount: "{count} dañados",
  possibleCount: "{count} posibles",
  noLocalEvidenceTitle: "Aún no hay evidencia localizada en esta ciudad",
  noLocalEvidenceBody:
    "Copernicus no ha publicado un área final aquí y todavía no hay necesidades comunitarias. Publicar un reporte ayuda a hacer visible el sector.",
  interactiveStats: "Estadísticas interactivas",
  destroyedBuildings: "Destruidos",
  damagedBuildings: "Dañados",
  possiblyDamagedBuildings: "Posibles",
  officialMappedDamage: "Daño oficial",
  findingsInPublicCell: "hallazgos CEMS en esta celda aproximada",
  reportEvidenceDisclaimer:
    "La ubicación pública es aproximada. Los hallazgos Copernicus solo cuentan dentro de la misma celda y no verifican este reporte comunitario.",
  menu: "Menú"
} as const;

type TranslationKey = keyof typeof es;

const en: Record<TranslationKey, string> = {
  appName: "Pulso",
  appCountry: "Colombia",
  appTagline: "Live aid map",
  pageTitle: "Pulso Colombia | Community aid map",
  pageDescription: "Bilingual community app for reporting needs, offering help, and coordinating support in Colombia.",
  map: "Community needs and help map",
  communityHubIntro: "Report needs, offer help, and connect with your community.",
  communityReports: "Community posts",
  officialMapReference: "View the official Copernicus EMSR916 map",
  peopleLabel: "People reported",
  urgentSectors: "Urgent sectors",
  urgentReports: "{count} urgent reports",
  skipToFeed: "Skip to list",
  emergency: "Immediate danger? Call 123",
  verifiedEvent: "Verified official event",
  eventFallback: "Updating earthquake data",
  updated: "Updated",
  agoMinutes: "{count} min ago",
  agoHours: "{count} hr ago",
  agoDays: "{count} d ago",
  needHelp: "I need help",
  offerHelp: "I want to help",
  signIn: "Sign in",
  signOut: "Sign out",
  inbox: "Messages",
  messagesCount: "{count} messages",
  admin: "Manage",
  adminTitle: "Manage posts",
  adminIntro:
    "Only the moderator account can see this view. Permanently delete test, duplicate, or unsafe posts here.",
  adminPostBy: "By {name}",
  noAdminPosts: "There are no active posts to manage.",
  inboxLoadError: "Messages could not be refreshed.",
  inboxSignedInAs: "Account: {name}",
  inboxAccountHint: "Account ID {id}",
  inboxDeviceHint:
    "To see the same inbox on another device, choose “I already have a code” and enter the same private code. Creating an account makes a separate inbox.",
  refreshInbox: "Refresh",
  refreshingInbox: "Refreshing",
  backToMessages: "Back to messages",
  selectConversation: "Select a conversation",
  selectConversationHint:
    "Open a message to coordinate privately.",
  waitingForResponse:
    "The other person must accept this offer before chat opens.",
  conversationClosed:
    "This conversation is closed and read-only.",
  language: "Language",
  selectCity: "City or region",
  allCities: "All",
  needsTab: "Community",
  areasTab: "Neighborhoods",
  resourcesTab: "Resources",
  openNeeds: "{count} active posts",
  noReportsTitle: "No community posts in this area yet",
  noReportsBody:
    "Post a need, available help, or update and place it approximately on the map.",
  filters: "Filters",
  filterAll: "All",
  statusOpen: "Open",
  statusMatched: "Aid coordinated",
  statusResolved: "Resolved",
  reportDetails: "Need details",
  availableHelpDetails: "Available help details",
  communityUpdateDetails: "Community update",
  reportedBy: "Posted by {name}",
  officialIntensity: "Instrumental intensity",
  communityConfirmations: "Community confirmation",
  urgency: "Urgency",
  severityLegend: "Urgency colors from 1 to 5",
  urgencyLevel: "Urgency {count} of 5",
  people: "{count} people",
  onePerson: "1 person",
  confirmations: "{count} confirmations",
  oneConfirmation: "1 confirmation",
  confirm: "Confirm nearby",
  confirmed: "Confirmed",
  sendOffer: "Send offer",
  contactAvailableHelp: "Contact",
  replyPrivately: "Reply",
  manage: "Manage",
  editPost: "Edit",
  reportFlag: "Report",
  discussion: "Public discussion",
  discussionCount: "{count} comments",
  commentsLoading: "Loading discussion",
  commentsLoadError: "The discussion could not be loaded.",
  noComments: "No comments yet.",
  commentPlaceholder: "Write a public comment",
  publicCommentNote: "Do not share phone numbers, email, or sensitive information.",
  publishComment: "Comment",
  publishingComment: "Posting",
  signInToComment: "Sign in to comment",
  commentsClosed: "The discussion closed when this post was resolved.",
  verifiedRepresentative: "Verified representative",
  communityMember: "Community member",
  approximateLocation: "Approximate location",
  mapLayers: "Layers",
  baseMap: "Base map",
  streetMap: "Streets",
  referenceImagery: "Satellite base",
  satellite: "Daily satellite",
  nasaDailyImagery: "Daily NASA (375 m)",
  shaking: "USGS intensity",
  modeledShaking: "USGS modeled shaking",
  observedShaking: "Shaking reported to USGS",
  officialDamageLayer: "Official Copernicus damage",
  communityNeeds: "Community network",
  aftershocks: "Aftershocks",
  satelliteDate: "Imagery date",
  satelliteResolution: "NASA VIIRS, approximately 375 m source resolution. Not suitable for building inspection.",
  locateMe: "Use my location",
  locating: "Finding location",
  locationError: "Your location is unavailable.",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  prioritySignal: "Priority index",
  priorityNote: "Combines USGS intensity and community reports. It is not a damage inspection.",
  noOfficialMmi: "No MMI estimate",
  mmiLabel: "MMI {value}",
  modeledMmi: "Modeled MMI {value}",
  observedCdi: "Observed CDI {value}",
  modelCellResolution: "~{value} km model cell",
  notObservedDamage: "This is not observed damage.",
  modeledNotDamage: "USGS model; not a damage inspection",
  dyfiResponses: "{count} USGS felt responses",
  noDyfiResponses: "No DYFI responses in this city",
  feltNotDamage: "Felt shaking; not building damage.",
  reportsLabel: "{count} reports",
  oneReport: "1 report",
  strongShaking: "Strong shaking",
  moderateShaking: "Moderate shaking",
  lightShaking: "Light shaking",
  liveSources: "Sources and method",
  dataSources: "Data sources",
  usgsSource: "USGS: event, aftershocks, ShakeMap, and ground-failure products.",
  nasaSource: "NASA GIBS/VIIRS: daily visible reflectance imagery.",
  copernicusSource:
    "Copernicus EMSR916: buildings classified through VHR imagery photo-interpretation and road interruptions, only within its analyzed areas.",
  communitySource: "Community: needs, confirmations, and coordination status.",
  methodology: "How it is calculated",
  methodologyBody:
    "Local sectors use H3 cells roughly 350 m across. Triage ordering uses 60×(1−exp(−(5D+3A+P)/12)) for Copernicus destroyed (D), damaged (A), and possibly damaged (P) findings; up to 30 points for community needs; and up to 10 for modeled MMI. The UI exposes the components instead of presenting a false damage number.",
  limitations: "Limitations",
  limitationsBody:
    "Copernicus confirms findings only inside analyzed areas; blank or pending areas do not mean no damage. Clouds, vegetation, and resolution can conceal damage. Esri imagery is reference imagery with varying capture dates; NASA VIIRS cannot inspect buildings. Verify on the ground before allocating resources.",
  openOfficialSource: "Open official source",
  authTitle: "Your Pulso account",
  authIntro: "No email is required. Your private code lets you return from another device.",
  createAccount: "Create account",
  restoreAccount: "I have a code",
  displayName: "Public name or alias",
  displayNameHint: "Do not use your legal name unless needed.",
  yourCity: "Your city or region",
  primaryCommunity: "Primary community",
  primaryCommunityNote:
    "Choose where you live or the community you want to support, even from outside Colombia.",
  accountType: "How are you participating?",
  accountResident: "Community",
  accountVolunteer: "Volunteer",
  accountSponsor: "Organization or donor",
  accountTypeNote: "This selection is informational and does not imply verification.",
  securityCheck: "Security check",
  securityCheckError: "The security check could not load. Try again.",
  recoveryCode: "Private access code",
  recoveryPlaceholder: "PULSO-XXXX-XXXX-...",
  continue: "Continue",
  creating: "Creating account",
  loggingIn: "Signing in",
  recoveryTitle: "Save your private code",
  recoveryBody: "Pulso cannot recover this code. Keep it off this device and never publish it.",
  copyCode: "Copy code",
  codeCopied: "Code copied",
  done: "Done",
  needFormTitle: "Post a need",
  needFormIntro:
    "Search an address or tap the map. The exact address is discarded and Pulso publishes only an approximate pin.",
  offerFormTitle: "Post available help",
  offerFormIntro:
    "Post on-site help with a pin or remote support from any country.",
  updateFormTitle: "Post an update",
  updateFormIntro:
    "Share a short localized notice about resources, access, fundraising, or area conditions.",
  editPostTitle: "Edit post",
  editPostIntro:
    "Correct the information, categories, or approximate location. Community confirmations reset when saved.",
  existingApproximateLocation: "Current approximate location",
  needPost: "Need",
  offerPost: "Available help",
  helpDeliveryMode: "Where is the help available?",
  localHelp: "On site",
  remoteHelp: "Remote help",
  localHelpModeNote:
    "Post an approximate pin so the community can find this local help.",
  remoteHelpModeNote:
    "Offer support from any country without publishing your personal location.",
  communityToSupport: "Community you want to support",
  remoteHelperLocationPrivate:
    "Your location is neither requested nor published.",
  supportingCommunity: "Remote support for {city}",
  remoteHelpFor: "Remote help for {city}",
  updatePost: "Update",
  mapInstruction: "Tap the map to choose an approximate location.",
  selectedLocation: "Location selected",
  chooseLocation: "Choose on map",
  findLocation: "Locate this post",
  addressPlaceholder: "Address, neighborhood, or landmark",
  searchAddress: "Search address",
  addressResults: "Address results",
  addressSearchMinimum: "Enter at least 3 characters to search.",
  addressNoResults: "No matching place was found inside the selected city.",
  mapClickFallback: "You can also tap the map",
  locationMap: "Map for choosing an approximate location",
  mapPointSelected: "Point selected on map",
  deviceLocationSelected: "Device location",
  locationOutsideCity: "The point must be inside the selected city or region.",
  publicCellPreview: "only an approximate pin is public; the exact address stays hidden",
  locationSelectionHint: "Search, use your location, or tap the map.",
  addressSearchCredit:
    "The query is sent to Nominatim; Pulso does not retain the search text. Data:",
  neighborhood: "Neighborhood or area",
  neighborhoodPlaceholder: "Example: La Enea",
  needs: "What is needed?",
  selectMultipleNeeds: "Select every category that applies.",
  needsSelected: "{count} selected: {needs}",
  offerCategories: "What can you provide?",
  updateCategories: "Update topic",
  needWater: "Water",
  needFood: "Food",
  needShelter: "Shelter",
  needMedical: "Medical care",
  needHygiene: "Hygiene",
  needRescue: "Rescue",
  needTransport: "Transport",
  needInformation: "Information",
  needFunds: "Financial support",
  affectedPeople: "People affected",
  peopleCanHelp: "People you can support",
  urgencyQuestion: "How urgent is it?",
  urgency1: "Can wait",
  urgency3: "Urgent",
  urgency5: "Critical",
  details: "Description",
  detailsPlaceholder:
    "Explain what happened, what is needed, quantities, people affected, timing, and access constraints.",
  offerDetailsPlaceholder:
    "Detail what you can provide, quantities, hours, coverage, pickup or delivery, and conditions.",
  updateDetailsPlaceholder:
    "State what changed, place and time, source, community impact, and how it can be verified.",
  needDetailsHint:
    "Include quantities, urgency, accessibility, and verifiable context. Keep phone and financial details in private messages.",
  offerDetailsHint:
    "Clarify capacity, availability, transport, and limits. Share personal contact details only in an accepted private conversation.",
  updateDetailsHint:
    "Add the date, source, and practical effect. Do not publish phone numbers, bank accounts, or personal data.",
  privacyWarning:
    "Do not publish an exact address, phone, email, bank account, or children's names. After accepting a trusted connection, coordinate contact details through Messages.",
  publishReport: "Post need",
  publishOffer: "Post help",
  publishUpdate: "Post update",
  publishing: "Publishing",
  saveChanges: "Save changes",
  savingChanges: "Saving",
  postUpdated: "Post updated",
  reportPublished: "Need published",
  helpPublished: "Available help published",
  updatePublished: "Update published",
  donateTitle: "Help safely",
  donateIntro: "Choose an official organization or respond to a specific need with a private message.",
  officialOrganizations: "Official organizations",
  directSupport: "Direct support",
  directSupportBody: "Open a map need and send an offer. The recipient accepts before details are coordinated.",
  postAvailableHelp: "Post available help",
  postUpdate: "Post",
  browseNeeds: "Browse needs",
  donationSafety: "Verify the domain and recipient. Pulso does not process money or charge fees.",
  officialInfo: "Official information",
  externalLink: "Opens an external site",
  offerTitle: "Offer help",
  offerTo: "Offer for {name}",
  contactTo: "Contact {name}",
  offerType: "Type of help",
  offerSupplies: "Supplies",
  offerTransport: "Transport",
  offerShelter: "Accommodation",
  offerMedical: "Medical support",
  offerVolunteer: "Volunteer time",
  offerFunds: "Financial contribution",
  offerOther: "Other",
  privateMessage: "Private message",
  privateMessagePlaceholder: "Explain what you can provide and how you prefer to coordinate.",
  contactMessagePlaceholder: "Explain what you need and how you prefer to coordinate safely.",
  replyMessagePlaceholder: "Write a private reply and explain how the information can be verified.",
  privateReply: "Private response",
  responsePlaceholder: "Share how to continue. You may include contact details here if you choose.",
  acceptResponse: "Accept and open chat",
  privateChat: "Private chat",
  openChat: "Open chat",
  closeChat: "Close chat",
  chatMessagePlaceholder: "Write a message",
  sendMessage: "Send message",
  noChatMessages: "There are no chat messages yet.",
  refreshChat: "Refresh chat",
  sendPrivateOffer: "Send private offer",
  sendPrivateMessage: "Send private message",
  sending: "Sending",
  offerSent: "Offer sent",
  messageSent: "Message sent",
  inboxTitle: "Private messages",
  received: "Received",
  sent: "Sent",
  noMessages: "There are no private conversations yet.",
  accept: "Accept",
  decline: "Decline",
  withdraw: "Withdraw",
  accepted: "Accepted",
  declined: "Declined",
  withdrawn: "Withdrawn",
  pending: "Pending",
  statusAvailable: "Available",
  statusCoordinating: "Coordinating",
  statusClosed: "Closed",
  statusPublished: "Published",
  offerExcludedFromRisk:
    "Available-help and update posts do not affect the priority index or affected-person estimate.",
  fundraiserSafety:
    "Fundraisers and payment links are unverified community information. Never post credentials or bank details, and verify the recipient before contributing.",
  coordinationSafety:
    "Share personal details only if you trust the other person. Pulso does not verify individual offers and deletes messages after 30 days.",
  close: "Close",
  cancel: "Cancel",
  save: "Save",
  markResolved: "Mark resolved",
  reopen: "Reopen",
  closePost: "Close post",
  reopenPost: "Post again",
  deletePost: "Delete",
  deletePostConfirmTitle: "Delete this post?",
  deletePostWarning:
    "This is permanent and also deletes its comments, connections, and private chat.",
  deletePermanently: "Delete permanently",
  postDeleted: "Post deleted",
  reportReason: "Why are you reporting this post?",
  reasonIncorrect: "Incorrect information",
  reasonDuplicate: "Duplicate",
  reasonUnsafe: "Exposes personal data",
  reasonFraud: "Possible fraud",
  reasonOther: "Other",
  flagSent: "Report submitted",
  loading: "Loading live data",
  refresh: "Refresh",
  retry: "Retry",
  genericError: "Something went wrong. Try again.",
  offline: "Offline. Showing the latest available information.",
  sourceOnline: "Live data",
  sourceCached: "Latest official data",
  imageryContext: "Context imagery",
  evidenceOfficial: "Official",
  evidenceCommunity: "Community",
  eventDepth: "{value} km deep",
  eventFelt: "{count} USGS responses",
  redAlert: "USGS red alert",
  landslideAlert: "Landslide risk: {value}",
  liquefactionAlert: "Liquefaction risk: {value}",
  footerDisclaimer: "Community tool. In an immediate emergency, call 123.",
  charCount: "{count}/{max}",
  required: "Required",
  locationPending: "Choose a location",
  categoryPending: "Select at least one category.",
  detailsPending: "Describe the situation using at least 10 characters.",
  securityPending: "Complete the security check.",
  accountRequired: "Sign in to continue.",
  loadFailure: "Live data could not be loaded.",
  satelliteLoadHint: "Imagery may load slowly or contain clouds.",
  cityScope: "In {city}",
  officialMappedArea: "Analyzed area",
  copernicusAcquisition: "{sensor}, imagery from {date}",
  destroyedBuilding: "Destroyed building",
  damagedBuilding: "Damaged building",
  possiblyDamagedBuilding: "Possibly damaged building",
  copernicusPhotoInterpretation: "Official Copernicus EMS photo-interpretation",
  blockedRoad: "Blocked road or interruption",
  blockedRoadsCount: "{count} road interruptions",
  communityPriority: "Community-need priority",
  officialDamageFindings: "{count} official building findings",
  officialMappingPending: "Official block mapping pending",
  layerEvidenceNote:
    "CEMS points are observed damage. DYFI is reported shaking and MMI is modeled; neither is building damage.",
  neighborhoodEvidence: "Neighborhood and sector evidence",
  neighborhoodEvidenceNote:
    "Ordered by Copernicus findings, critical needs, and modeled shaking. Each row exposes its available components; missing coverage is not evidence of no damage.",
  officialCoverageAvailable: "Official block-level coverage available",
  mappedSector: "Mapped sector {count}",
  priorityCritical: "Critical",
  priorityHigh: "High",
  priorityActive: "Active",
  destroyedCount: "{count} destroyed",
  damagedCount: "{count} damaged",
  possibleCount: "{count} possible",
  noLocalEvidenceTitle: "No localized evidence in this city yet",
  noLocalEvidenceBody:
    "Copernicus has not published a final area here and there are no community needs yet. Posting a report makes the area visible.",
  interactiveStats: "Interactive statistics",
  destroyedBuildings: "Destroyed",
  damagedBuildings: "Damaged",
  possiblyDamagedBuildings: "Possible",
  officialMappedDamage: "Official damage",
  findingsInPublicCell: "CEMS findings in this approximate cell",
  reportEvidenceDisclaimer:
    "The public location is approximate. Copernicus findings count only within the same cell and do not verify this community report.",
  menu: "Menu"
};

const dictionaries = { es, en };

export type TFunction = (key: TranslationKey, values?: Record<string, string | number>) => string;

export function createTranslator(language: Language): TFunction {
  return (key, values = {}) => {
    let text = dictionaries[language][key] ?? es[key];
    for (const [name, value] of Object.entries(values)) {
      text = text.replaceAll(`{${name}}`, String(value));
    }
    return text;
  };
}

export function detectLanguage(): Language {
  const stored = localStorage.getItem("pulso-language");
  if (stored === "es" || stored === "en") return stored;
  return navigator.language.toLowerCase().startsWith("es") ? "es" : "en";
}
